import React from 'react'
import BkPixel from './BkPixel'
import { stitchText } from './pixelType'
import { bkHit, BK_TIMER } from './layout'

/**
 * The seconds a page has left, in the one corner that is clear on every plate
 * (bottom-right, on the lace border — checked against all of them). Nothing
 * renders when the page has no timeout. The last ten seconds turn red, the
 * stock convention for "about to move on without you".
 */
const BkTimer: React.FC<{ seconds: number | null }> = ({ seconds }) => {
  if (seconds === null) return null
  const m = Math.floor(seconds / 60)
  const s = String(seconds % 60).padStart(2, '0')
  const urgent = seconds <= 10
  return (
    <div
      aria-live="polite"
      style={bkHit(BK_TIMER)}
      className="pointer-events-none z-40 flex items-center justify-center rounded-full bg-[#F0EEDC] shadow-[0_2px_6px_rgba(0,0,0,0.25)]"
    >
      {/* In the plates' block lettering, like every other word on screen. */}
      <BkPixel rows={stitchText(`${m}:${s}`)} block={4} color={urgent ? '#B3202E' : undefined} />
    </div>
  )
}

export default BkTimer
